/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import { Dispatch, SetStateAction } from "react";
import { isTokenError } from "../api/core/BaseService";

export interface DialogState {
    open: boolean;
    message?: string | string[];
    resolve?: (result: boolean) => void;
    reject?: () => void;
}

export interface ShowErrorMessageProps {
    message: string | string[];
    error?: unknown;
    resolve?: (result: boolean) => void;
}

export interface ShowInfoMessageProps {
    message: string | string[];
    resolve?: (result: boolean) => void;
}

export interface ShowConfirmMessageProps {
    message: string | string[];
    resolve?: (result: boolean) => void;
    reject?: () => void;
}

/**
 * ##################################################################
 * ### トークンエラーダイアログ
 * ##################################################################
 */
// Global states.
let _tokenErrorOpen: boolean;
let _setTokenErrorOpen: Dispatch<SetStateAction<boolean>>;

export const setTokenErrorOpenSetter = (setTokenErrorOpen: Dispatch<SetStateAction<boolean>>) => {
    _setTokenErrorOpen = setTokenErrorOpen;
};

export const setTokenErrorOpen = (tokenErrorOpen: boolean) => {
    _tokenErrorOpen = tokenErrorOpen;
};

const openTokenErrorDialog = (bool: boolean) => {
    if (!_tokenErrorOpen) {
        _setTokenErrorOpen(bool);
    }
};

/**
 * ##################################################################
 * ### エラーダイアログ
 * ##################################################################
 */
// Global states.
let _error: DialogState;
let _setError: Dispatch<SetStateAction<DialogState>>;

export const setErrorSetter = (setError: Dispatch<SetStateAction<DialogState>>) => {
    _setError = setError;
};

export const setError = (error: DialogState) => {
    _error = error;
};

const openErrorDialog = (error: DialogState) => {
    if (!_error.open) {
        _setError(error);
    }
};

export const showErrorMessage = (props: ShowErrorMessageProps) => {
    const { message, error, resolve } = props;
    if (isTokenError(error)) {
        openTokenErrorDialog(true);
        return;
    }
    openErrorDialog({
        open: true,
        message,
        resolve,
    });
};

/*
 * ##################################################################
 * ### インフォメーションダイアログ
 * ##################################################################
 */
// Global states.
let _information: DialogState;
let _setInformation: Dispatch<SetStateAction<DialogState>>;

export const setInformationSetter = (setInformation: Dispatch<SetStateAction<DialogState>>) => {
    _setInformation = setInformation;
};

export const setInformation = (information: DialogState) => {
    _information = information;
};

export const openInformationDialog = (props: ShowInfoMessageProps) => {
    const { message, resolve } = props;
    if (!_information.open) {
        _setInformation({
            open: true,
            message,
            resolve,
        });
    }
};

/*
 * ##################################################################
 * ### 確認ダイアログ
 * ##################################################################
 */
// Global states.
let _confirmation: DialogState;
let _setConfirmation: Dispatch<SetStateAction<DialogState>>;

export const setConfirmationSetter = (setConfirmation: Dispatch<SetStateAction<DialogState>>) => {
    // console.log("setConfirmationSetter", setConfirmation);
    _setConfirmation = setConfirmation;
};

export const setConfirmation = (confirmation: DialogState) => {
    // console.log("setConfirmation", confirmation);
    _confirmation = confirmation;
};

export const openConfirmationDialog = (props: ShowConfirmMessageProps) => {
    const { message, resolve, reject } = props;
    // console.log("openConfirmationDialog", props);
    if (!_confirmation.open) {
        _setConfirmation({
            open: true,
            message,
            resolve,
            reject,
        });
    }
};
